import { createSlice } from "@reduxjs/toolkit";
import { googleLogin, loginUser } from "./authThunks";

const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      state.token = null;
      localStorage.removeItem("token");
      localStorage.removeItem("vendor");
      localStorage.removeItem("member");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user || action.payload;
        state.token = action.payload.token || null;
        if (state.token) {
          localStorage.setItem("token", state.token);
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(googleLogin.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(googleLogin.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
        console.log("action.payload", action.payload);

        if (action.payload.user.account_type === "partner") {
          localStorage.setItem(
            "member",
            JSON.stringify(action.payload.userData)
          );
        }
        if (action.payload.user.account_type === "vendor") {
          localStorage.setItem(
            "vendor",
            JSON.stringify(action.payload.userData)
          );
        }
      })
      .addCase(googleLogin.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
